export const activityCodes = [
	['Vacant', '90 - Vacant', [255, 0, 255]],
	['Agricultural Land', '91 - Agricultural Land', [255, 150, 0]],
	[
		'Limited Development Potential',
		'92 - Limited Development Potential',
		[255, 0, 255],
	],
	['Platted Parcel', '93 - Developing Site - Unavailable', [0, 0, 255]],
	[
		'New Serviceable Lot',
		'94 - Developing Site - New serviceable lot',
		[0, 0, 255],
	],
	['Redevolping Lot', '95 - Developing Site - Redeveloping lot', [0, 0, 255]],
	[
		'Residential Building Permit',
		'96 - Residential Building Permit',
		[255, 0, 0],
	],
	[
		'Non Residential Building Permit',
		'97 - Non-Residential Building Permit',
		[255, 0, 0],
	],
	[
		'Approved Subdivision',
		'98 - Developing Site - Preliminary Plan',
		[255, 0, 255],
	],
];
